import React from 'react'
import Chart from 'react-google-charts';

export const AreaChart1 = () => {
    const data = [
        ["Year", "Sales"],
        ["2013", 1000],
        ["2014", 1170],
        ["2015", 660],
        ["2016", 1030],
    ];

    const options = {
        isStacked: true,
        legend: "none",
        vAxis: { minValue: 0 },
        hAxis: { textPosition: "none" },
        chartArea: { left: 0, top: 0, width: "100%", height: "100%" },
        colors: ["#2d7a9f"],
        lineWidth: 0,
        pointSize: 0,
        areaOpacity: 0.7,
    };
    return (
        <Chart
            chartType="AreaChart"
            width="100%"
            height="170px"
            className='p-0 m-0'
            data={data}
            options={options}
        />
    )
}
